import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { TranslationHelper } from "app/helpers/translationHelper";
import { BetSlipType } from "app/types/betSlipType";
import { EventMarketType } from "app/types/eventType";
import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * Props for the MarketName component.
 * @typedef {Object} MarketNameProps
 * @property {BetSlipType} betSlip The bet slip object.
 */

type MarketNameProps = {
  betSlip: BetSlipType;
};

/**
 * The MarketName component displays the formatted name of a market.
 * It extracts the market from the bet slip and formats the name based on the market type.
 *
 * @param {MarketNameProps} props The component props.
 * @returns {React.ReactNode} The JSX element for the market name.
 */
const MarketName: React.FC<MarketNameProps> = ({ betSlip }) => {
  const betSlipMarket: EventMarketType | null =
    BetSlipHelper.getBetSlipMarket(betSlip);
  const homeTeam = betSlip.showHomePlayerAsFirst
    ? betSlip.participant1
    : betSlip.participant2;
  const awayTeam = betSlip.showHomePlayerAsFirst
    ? betSlip.participant2
    : betSlip.participant1;

  if (!betSlipMarket) return null;

  return (
    <FormattedMessage
      tagName="span"
      id={TranslationHelper.getTranslationIdForMarket(
        betSlipMarket.type,
        betSlipMarket.period,
        betSlip.sportType,
        true
      )}
      values={{
        homeTeam,
        awayTeam,
      }}
    />
  );
};

export default MarketName;
